import { z } from "zod";

const boostQuoteSchema = z
  .object({
    quote_token: z.string(),
    subtotal: z.number(),
    tax_amount: z.number(),
    total_amount: z.number(),
  })
  .transform((input) => ({
    quoteToken: input.quote_token,
    subtotal: input.subtotal,
    taxAmount: input.tax_amount,
    totalAmount: input.total_amount,
    fetchedAt: Date.now(),
  }));

type BoostQuote = z.infer<typeof boostQuoteSchema>;

export { boostQuoteSchema, type BoostQuote };
